const COLUMN_SEPARATOR = ",";

/**
 * Return the content of a csv file
 * @param data E.g. [{id: 1, name: "Josh"}]
 * @param headerMap E.g. {id: "ID", name: "Name"}
 */
export function createCsvContent<T extends object>(
  data: T[],
  headerMap: { [key in keyof T]: string },
) {
  const headerKeys = Object.keys(headerMap);
  const headerLine = headerKeys
    .map((key) => headerMap[key as keyof T])
    .join(COLUMN_SEPARATOR);
  const contentLines = data
    .map((item) => {
      return headerKeys
        .map((key) => item[key as keyof T])
        .join(COLUMN_SEPARATOR);
    })
    .join("\n");
  return `${headerLine}\n${contentLines}`;
}
